import React from 'react';
import { PlaceholderUFOMigration as Placeholder } from '@atlassian/jira-placeholder/src/index.tsx';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';
import { FieldLoader } from '@atlassian/jira-issue-create-commons/src/common/ui/field-loader/index.tsx';
import { FieldContainer } from '@atlassian/jira-issue-create-commons/src/common/ui/fields/styled.tsx';
import { withFormField } from '@atlassian/jira-issue-create-commons/src/common/ui/with-form-field/index.tsx';
import { closeMenuOnScroll } from '@atlassian/jira-issue-create-commons/src/common/utils/select/index.tsx';
import {
	ContextualAnalyticsData,
	FireScreenAnalytics,
	MODAL,
} from '@atlassian/jira-product-analytics-bridge';
import { useProjectId, useProjectKey } from '@atlassian/jira-project-context-service/src/main.tsx';
import { useIssueKey } from '@atlassian/jira-issue-context-service/src/main.tsx';
import { useCommonPageContext } from '@atlassian/jira-servicedesk-common-page-context/src/index.tsx';
import { EditView as OrganizationFieldEditView } from '../../common/ui/organization-edit-view/index.tsx';
import type { Props, OrganizationFieldConfig, FieldValue } from './types.tsx';
import { validateOrganizationField } from './utils.tsx';

export const OrganizationField = (props: Props) => {
	const {
		width,
		autoFocus = false,
		fieldProps: { value, onChange, ...fieldProps },
		onCloseMenuOnScroll = closeMenuOnScroll,
		isDropdownMenuFixedAndLayered = false,
		error,
		searchUrl,
	} = props;

	const issueKey = useIssueKey();
	const projectKey = useProjectKey(issueKey);
	const projectId = useProjectId(projectKey);
	const { projectId: projectIdNoIssueKey } = useCommonPageContext();
	const finalProjectId = issueKey ? projectId : projectIdNoIssueKey;
	const autoCompleteUrl =
		searchUrl || `/rest/servicedesk/1/project/${finalProjectId}/organisations/all/search`;

	return (
		<FieldContainer width={width}>
			<Placeholder name="organization-edit" fallback={<FieldLoader />}>
				<ContextualAnalyticsData sourceName="organizationFieldGIC" sourceType={MODAL}>
					<FireScreenAnalytics
						attributes={{
							organizationFieldViewed: 'GIC',
						}}
					/>
				</ContextualAnalyticsData>
				<OrganizationFieldEditView
					{...fieldProps}
					isInvalid={Boolean(error)}
					isDropdownMenuFixedAndLayered={isDropdownMenuFixedAndLayered}
					onChange={onChange}
					value={value}
					autoFocus={autoFocus}
					onCloseMenuOnScroll={onCloseMenuOnScroll}
					spacing="default"
					searchUrl={autoCompleteUrl}
				/>
			</Placeholder>
		</FieldContainer>
	);
};

export const OrganizationFieldWithErrorBoundary = (props: Props) => {
	return (
		<JSErrorBoundary
			id="organizationField"
			packageName="jiraServicedeskCustomerServiceOrganizationField"
			teamName="boysenberry"
			sendToPrivacyUnsafeSplunk
			fallback="unmount"
		>
			<OrganizationField {...props} />
		</JSErrorBoundary>
	);
};

export const IssueCreateOrganizationField = withFormField<FieldValue, FieldValue>({
	validator: validateOrganizationField,
	// @ts-expect-error - TS2345 - Argument of type '(props: Props) => JSX.Element' is not assignable to parameter of type 'AbstractComponent<ComponentProps<OrganizationFieldConfig, FieldValue>, any>'.
})<OrganizationFieldConfig, FieldValue>(OrganizationFieldWithErrorBoundary);
